import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { EnvUtils } from '@ecm/dispatcher';
import { MaterialFeedbackComponent } from '@ecm/material';

import { Error } from '../../business/error';
import { ElcosService } from '../../services/elcos.service';
import { TitleService } from '../../services/title.service';

@Component({
    selector: 'ecm-unauthorized',
    templateUrl: 'unauthorized.html',
    standalone: true,
    imports: [MaterialFeedbackComponent],
})
export class UnauthorizedComponent implements OnInit {
    /**
     * Error object for interpolation
     * @type {Error}
     */
    public error: Error;

    /**
     * Unauthorized redirection link label
     */
    public redirectLabel: string;

    /**
     * link's style
     */
    public linkStyle: string;

    /**
     * Orange common URL for authentication
     */
    private redirectUrl: string;

    public constructor(
        private translateService: TranslateService,
        private elcosService: ElcosService,
        private route: ActivatedRoute,
        private titleService: TitleService,
    ) {
        this.error = new Error();
        this.translateService.use('i18n');
    }

    public ngOnInit(): void {
        // load Orange elcos
        this.elcosService.switchToOrange();
        // get i18n
        this.translateService.get('ecm.error.unauthorized').subscribe((i18n) => {
            this.route.params.subscribe((params) => {
                const returnUrl: string = params['returnUrl'];
                this.error.title = i18n['title'];
                this.error.description = i18n['description'];
                // display authentication form link only for web customers
                if (!EnvUtils.isEclair() && !EnvUtils.isWebview()) {
                    this.redirectLabel = i18n['redirect-label'];
                    this.linkStyle = 'link';
                    this.redirectUrl = i18n['redirect-url'].concat(returnUrl);
                }
                // update tab title
                this.titleService.setTitle(i18n['nav-title']);
            });
        });
    }

    /**
     * Create redirection link to Orange login/authentication page, with return URL to ecm application
     * @returns {string}
     */
    public redirectionLink(): string {
        return (window.location.href = this.redirectUrl);
    }
}
